import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { FaBirthdayCake, FaRing } from "react-icons/fa";

export default function Cumpleanios() {
  const [cumpleanios, setCumpleanios] = useState([]);
  const [loading, setLoading] = useState(true);
  const { token } = useContext(AuthContext);

  // Función para obtener iniciales
  // El nombre llega como CONCAT(nombre, paterno, materno): si falta algún
  // apellido quedan espacios sobrantes, que no deben generar palabras vacías.
  const obtenerIniciales = (nombreCompleto = "") =>
    nombreCompleto
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((p) => p[0].toUpperCase())
      .join("");

  useEffect(() => {
    const fetchCumpleanios = async () => {
      try {
        const response = await fetch("/api/miembros/cumpleanios", {
          credentials: "include",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await response.json();
        setCumpleanios(data);
      } catch (error) {
        console.error("Error cargando cumpleaños:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCumpleanios();
  }, [token]);

  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
      <div className="flex items-center gap-2 mb-4">
        <span className="w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center">
          <FaBirthdayCake />
        </span>
        <h2 className="text-base font-semibold text-slate-800">Próximos Cumpleaños</h2>
      </div>

      {loading ? (
        <p className="text-sm text-slate-400 text-center py-6">Cargando cumpleaños...</p>
      ) : cumpleanios.length === 0 ? (
        <p className="text-sm text-slate-400 text-center py-6">No hay cumpleaños próximos.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {cumpleanios.map((miembro) => (
            <div
              key={miembro.id_miembro}
              className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg hover:bg-indigo-50 transition"
            >
              {/* Avatar con iniciales */}
              <div className="w-11 h-11 rounded-full bg-indigo-600 text-white flex items-center justify-center font-semibold text-sm shrink-0">
                {obtenerIniciales(miembro.nombre_completo)}
              </div>

              <div className="min-w-0">
                <p className="font-medium text-sm text-slate-800 truncate">
                  {miembro.nombre_completo}
                </p>
                <p className="text-xs text-slate-500">
                  {miembro.dia} de {miembro.mes} ({miembro.edad_que_cumple} años)
                </p>
                {miembro.aniversario && (
                  <p className="text-xs text-slate-500 flex items-center gap-1">
                    <FaRing className="text-[10px]" />
                    {new Date(miembro.aniversario).toLocaleDateString("es-ES", { timeZone: "UTC" })}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}